const setPath = (text, value) => `${text}=${value}&`;

export const queryBuilder = (query) => {
  let path = '?';
  for (const key of Object.keys(query)) {
    path += setPath(key, query[key]);
  }
  return path;
};

export const formatDataUrlParameters = (value) => (value instanceof Object ? JSON.stringify(value) : value);

export const formatUrlDateRange = (value, type) => {
  const date = value && JSON.parse(value)[type] ? JSON.parse(value)[type] : '';
  return date;
};
